import React, { useEffect, createElement } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialsSection1, TestimonialsSection2 } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1975701953338788');
    window.fbq('track', 'PageView');
  }, []);
  const closingChecklist = ['TOMO 1: Mentalidad y Psicología del Dinero', 'TOMO 2: El Mapa del Tesoro — Presupuesto y Gestión', 'TOMO 3: Bancos, Crédito y el Costo Real de la Deuda', 'TOMO 4: El Mundo de las Inversiones', 'TOMO 5: Emprendimiento e Ideación', 'TOMO 6: Ciudadanía Financiera, Ética y Protección', 'BONO 1: Guía de Gamificación — 5 Dinámicas de Grupo', 'BONO 2: Plantilla de Planificación Anual', 'BONO 3: Banco de Evaluaciones y Rúbricas', 'BONO 4: Manual de Respuestas para Preguntas Difíciles', 'Actualizaciones de por vida', 'Edición 2026 — Español Neutro — 100% Editable', 'Entrega inmediata en menos de 5 minutos', 'Garantía de devolución total — 7 días sin preguntas'];
  const cadaSemanaSinElKit = ['Sin más noches buscando material que no funciona', 'Sin más actividades armadas de apuro', 'Sin más evaluaciones construidas bajo presión', 'Sin más alumnos que hacen las tareas con IA porque no tuvieron una mejor propuesta', 'Sin más energía gastada en planificación que podría ir a tus estudiantes'];
  return <div className="min-h-screen bg-brand-dark font-sans pb-16 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <TestimonialsSection1 data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductShowcase data-id="element-5" />
      <Bonuses data-id="element-6" />
      <PurchaseSection id="compra" data-id="element-7" />
      <TestimonialsSection2 data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />

      {/* Closing CTA Section */}
      <section className="py-7 md:py-10 px-4 bg-brand-dark text-center border-t border-brand-accent/10" data-id="element-11">
        <div className="max-w-3xl mx-auto" data-id="element-12">
          <h2 className="text-lg md:text-2xl font-black text-white mb-2 tracking-tight leading-tight uppercase" data-id="element-13">
            El próximo lunes puedes seguir improvisando con conceptos que tus
            alumnos ignoran...
          </h2>
          <p className="text-xl md:text-3xl font-black text-brand-accent neon-glow mb-4 uppercase" data-id="element-14">
            O puedes tener todo resuelto desde hoy.
          </p>

          <div className="bg-brand-card border-l-4 border-red-500 rounded-r-lg p-4 md:p-5 text-left mb-6 max-w-2xl mx-auto" data-id="element-15">
            <div className="space-y-2" data-id="element-16">
              {cadaSemanaSinElKit.map((point, i) => <div key={i} className="flex items-start" data-id="element-17">
                  <span className="text-red-500 mr-2 shrink-0" data-id="element-18">▸</span>
                  <p className="text-xs md:text-sm text-gray-300 font-bold leading-relaxed" data-id="element-19">
                    {point}
                  </p>
                </div>)}
            </div>
          </div>

          <div className="space-y-2 mb-6" data-id="element-20">
            <p className="text-base md:text-xl text-white font-black leading-tight" data-id="element-21">
              El Kit Completo Educación Financiera Lista{' '}
              <span className="text-brand-accent neon-glow" data-id="element-22">
                no te convierte en mejor docente
              </span>
              .
            </p>
            <p className="text-sm md:text-base text-gray-300 font-bold italic" data-id="element-23">
              Vos ya eres un buen docente.
            </p>
            <p className="text-sm md:text-base text-white font-bold leading-relaxed max-w-xl mx-auto" data-id="element-24">
              Lo que hace el Kit es darte el{' '}
              <span className="text-brand-accent" data-id="element-25">tiempo</span> y las{' '}
              <span className="text-brand-accent" data-id="element-26">herramientas</span> para que
              eso se note en cada clase.
            </p>
          </div>

          <div className="bg-brand-card border-2 border-brand-accent/50 rounded-lg p-4 md:p-6 text-left mb-6 max-w-2xl mx-auto shadow-[0_0_25px_rgba(34,197,94,0.2)]" data-id="element-27">
            <div className="space-y-2.5" data-id="element-28">
              {closingChecklist.map((item, i) => <div key={i} className="flex items-start" data-id="element-29">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-brand-accent mr-2.5 shrink-0 mt-0.5" data-id="element-30" />
                  <span className="text-xs md:text-sm text-gray-200 font-bold leading-relaxed" data-id="element-31">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Final Quote */}
      <section className="py-6 md:py-8 px-4 bg-brand-dark border-t border-brand-accent/10 text-center" data-id="element-32">
        <div className="max-w-2xl mx-auto" data-id="element-33">
          <p className="text-base md:text-xl text-white font-black italic leading-relaxed" data-id="element-34">
            "El mejor momento para enseñar esto era al inicio del año.
            <br className="hidden md:block" data-id="element-35" />
            <span className="text-brand-accent neon-glow" data-id="element-36">
              {' '}
              El segundo mejor momento es hoy.
            </span>
            "
          </p>
        </div>
      </section>

      <Footer data-id="element-37" />
      <SocialProofPopup data-id="element-38" />
      <StickyMobileCTA data-id="element-39" />

      <noscript data-id="element-40">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1975701953338788&ev=PageView&noscript=1" alt="" data-id="element-41" />
      </noscript>
    </div>;
}